import * as yup from 'yup';

export const validationScheme = yup
  .object()
  .shape({
    promocodeValue: yup.string().required('shared.error.required'),
  })
  .required();
